import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "pagination",
  role: "pagination",
  "aria-label": "Products Navigation"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("First")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Previous")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Last")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_ctx.firstButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          format: "button",
          type: "button",
          border: true,
          status: _ctx.isFirstPage ? 'disabled' : '',
          onHandleClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pageChange(1))),
          ariaLabel: "Go to first"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["status"]))
      : _createCommentVNode("", true),
    (_ctx.prevButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          format: "button",
          type: "button",
          border: true,
          status: _ctx.isFirstPage ? 'disabled' : '',
          onHandleClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageChange(_ctx.currentPage - 1))),
          ariaLabel: "Go to previous"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["status"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPaginationButtons, (page, index) => {
      return (_openBlock(), _createBlock(_component_Button, {
        format: "button",
        type: "button",
        border: true,
        status: _ctx.currentPage === page ? 'active' : '',
        key: index,
        onHandleClick: ($event: any) => (_ctx.currentPage !== page && _ctx.pageChange(page)),
        ariaCurrent: _ctx.currentPage === page,
        ariaLabel: (_ctx.currentPage == page ? 'Current page, page ' : 'Go page ') + page
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(page), 1)
        ]),
        _: 2
      }, 1032, ["status", "onHandleClick", "ariaCurrent", "ariaLabel"]))
    }), 128)),
    (_ctx.nextButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          format: "button",
          type: "button",
          border: true,
          status: _ctx.isLastPage ? 'disabled' : '',
          onHandleClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pageChange(_ctx.currentPage + 1))),
          ariaLabel: "Go to next"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["status"]))
      : _createCommentVNode("", true),
    (_ctx.lastButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 3,
          format: "button",
          type: "button",
          border: true,
          status: _ctx.isLastPage ? 'disabled' : '',
          onHandleClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pageChange(_ctx.totalPages))),
          ariaLabel: "Go to last"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["status"]))
      : _createCommentVNode("", true)
  ]))
}